import { render, staticRenderFns } from "./useridlockEdit.vue?vue&type=template&id=e451735c&scoped=true"
import script from "./useridlockEdit.vue?vue&type=script&lang=js"
export * from "./useridlockEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e451735c",
  null
  
)

export default component.exports